import './home_files/price-toggle';
import './home_files/typing-processes-names';
import './home_files/customers-carousel';
import './home_files/regional_discount';
